var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57721 1.37835C6.91939 0.558658 8.08068 0.558658 8.42286 1.37835L9.50419 3.9687C9.64094 4.29629 9.94111 4.52683 10.2929 4.57444L13.2168 4.97018C14.0837 5.08751 14.3927 6.18283 13.715 6.73592L11.4873 8.55379C11.1919 8.79478 11.0593 9.18268 11.1452 9.55402L11.8556 12.6236C12.0624 13.5172 11.0576 14.1945 10.3068 13.6676L8.07452 12.1008C7.72975 11.8588 7.27032 11.8588 6.92555 12.1008L4.69317 13.6676C3.94246 14.1945 2.93767 13.5172 3.14443 12.6237L3.85473 9.554C3.94066 9.18267 3.80802 8.79478 3.51272 8.5538L1.28507 6.73591C0.607301 6.18282 0.916296 5.08752 1.7832 4.97019L4.70718 4.57444C5.05896 4.52683 5.35913 4.29629 5.49588 3.9687L6.57721 1.37835Z",
    fill: "#00DF31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1fe34df16ebc1f63b0fd46ef0f9e257b.svg";
export { ForwardRef as ReactComponent };